import type { TGoto } from './types';

export const withHookMoveToLink = (
  goto: TGoto,
  paramLeadId: string,
  link: string,
  searchParams?: string,
  isSpecial?: boolean
) => {
  let fLink = link;
  if (isSpecial) {
    fLink = link;
  }

  fLink += `/${paramLeadId}`;

  if (searchParams) {
    fLink += `/${searchParams}`;
  }

  if (window.location.search) {
    fLink += `/${window.location.search}`;
  }

  goto(fLink);
};
